<div class="card" *blockUI="'section-block'">
    <div class="row mt-1 mb-1 d-flex justify-content-between">
        <div class="d-flex align-items-center ml-2" *ngIf="authService.isEndpointStatus('POST.Writing.CreateTransactions')">
            <a href="#/admin/mexpensetransaction-create">
                <button class="btn btn-primary" rippleEffect>
                    <i data-feather="plus" class="d-sm-none d-inline-block"></i>
                    <span class="d-none d-sm-inline-block">Masraf Ekle</span>
                </button>
            </a>
        </div>

        <div class="d-flex justify-content-end mr-2">
            <div ngbDropdown [placement]="'left'" class="btn-group dropup dropdown-icon-wrapper">
                <button ngbDropdownToggle type="button" class="btn btn-icon btn-flat-primary dropdown-toggle-split"
                    rippleEffect>
                    <span [data-feather]="'more-vertical'" class="'dropdown-icon'"></span>
                </button>
                <div ngbDropdownMenu>
                    <span ngbDropdownItem (click)="exportAsExcelFile()">Excel'e Aktar</span>
                </div>
            </div>
            <div class="d-flex align-items-center">
                <div class="mr-1">
                    <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </div>
                <div>
                    <input type="search" placeholder="Bul" class="form-control" (keyup)="filterUpdate($event)"
                        (search)="filterUpdate($event)" />
                </div>
            </div>
        </div>
    </div>

    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam',
        selectedMessage: 'Seçili'}" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50"
        [footerHeight]="50" [scrollbarH]="true" (activate)="onActivate($event)">

        <ngx-datatable-column name="Belge No" [width]="100">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.documentNo ?? row.no}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="İşlem Yapan Kişi" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.name ?? '' }} {{row.lastName ?? ''}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="İşlem Tarihi" [width]="100">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.transactionCraetedAt |date:'dd.MM.yyyy'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Proje" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.projects[0]?.name ?? '-'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="İşlem Türü" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.expenseTransactions[0].name}} - {{row.expenseTransactions[0].typeName}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="İşlem Tutarı" [width]="100">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.transactionProducts[0].productPrice | number:'1.2-2'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event,row)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>

    <core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="create-kind" overlayClass="modal-backdrop">
        <app-create-kind [kind]="selectedKind"></app-create-kind>
    </core-sidebar>
</div>